import { useSelector } from "react-redux";
import {
  acceptTermsAndConditions,
  getTermsAndConditions,
  selectLoading,
  selectTermsAndConditionsAccepted,
  selectTermsAndConditionsContent,
} from "./TermsAndConditionsSlice";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useEffect } from "react";
import { Field, Formik } from "formik";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { sanitizeHtml } from "cpl-react-common/Helpers/HtmlSanitizerHelpers";

const TermsAndConditionsPage = () => {
  const termsAndConditionsContent = useSelector(selectTermsAndConditionsContent);
  const loading = useSelector(selectLoading);
  const termsAndConditionsAccepted = useSelector(selectTermsAndConditionsAccepted);
  const thunkDispatch = useThunkDispatch();

  useEffect(() => {
    thunkDispatch(getTermsAndConditions());
    return () => {
      document.body.style.backgroundImage = `none`;
    };
  }, [thunkDispatch]);

  const onSubmit = async (values) => {
    if (values.termsAccepted !== true) {
      toast.error("You must accept terms and conditions to continue");
    }
    thunkDispatch(acceptTermsAndConditions());
  };

  useEffect(() => {
    if (termsAndConditionsAccepted) {
      window.location.href = "/dashboard";
    }
  }, [termsAndConditionsAccepted]);

  return (
    <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Wrapper */}
        <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
          <ActivityIndicator isBusy={loading}>
            <div className="card-header">
              <div className="card-title m-0">
                <h3 className="fw-bolder m-0">Terms And Conditions</h3>
              </div>
            </div>
            <div className="card-body border-top p-9 d-flex flex-column gap-4">
              <Formik initialValues={{ termsAccepted: false }} onSubmit={onSubmit}>
                {({ handleSubmit }) => (
                  <Form onSubmit={handleSubmit}>
                    <div
                      className="mb-4"
                      dangerouslySetInnerHTML={{ __html: sanitizeHtml(termsAndConditionsContent) }}
                    ></div>
                    <div className="separator mb-4" />
                    <div className="d-flex gap-2">
                      <Field
                        id="cbAccept"
                        className="form-check-input"
                        name="termsAccepted"
                        type="checkbox"
                        required
                        data-test-id="terms-and-conditions-form__accept-checkbox"
                      />
                      <label htmlFor="cbAccept">Yes, I agree to the terms and conditions</label>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        type="submit"
                        className="cpl-btn cpl-btn-primary mt-4"
                        data-test-id="terms-and-conditions-form__submit-button"
                      >
                        Continue
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ActivityIndicator>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
    </div>
  );
};

export default TermsAndConditionsPage;
